import React, { useState } from 'react';
import { Container, Row, Col, Spinner } from 'react-bootstrap';
import JobCard from './JobCard';
import JobFilters from './JobFilters';
import { useSearchParams } from 'react-router-dom';
import jobListings from './dummyJobs'; // Import dummy job listings

const JobList = ({ jobs = jobListings, loading = false }) => { // Default to dummy job listings and set loading to false for testing
  const [searchParams] = useSearchParams();
  const jobTitle = searchParams.get('title');
  const city = searchParams.get('city');
 jobs=jobListings;
  const [filteredJobs, setFilteredJobs] = useState(jobs);

  const handleFilter = (filters) => {
    const { location, category, experience } = filters;
    let filtered = jobs;

    if (location) {
      filtered = filtered.filter((job) =>
        job.location.toLowerCase().includes(location.toLowerCase())
      );
    }

    if (category) {
      filtered = filtered.filter((job) => job.category === category);
    }

    if (experience) {
      filtered = filtered.filter((job) =>
        job.experience.toLowerCase().includes(experience.toLowerCase())
      );
    }

    setFilteredJobs(filtered);
  };

  console.log({ jobTitle, city }); // Verify if parameters are correctly fetched
  console.log('Job Listings:', jobs); // Verify if jobs array is correctly passed

  if (loading) {
    return (
      <Container className="d-flex justify-content-center mt-3">
        <Spinner animation="border" />
      </Container>
    );
  }

  if (filteredJobs.length === 0) {
    return (
      <Container className="d-flex justify-content-center align-items-center flex-column mt-3">
        <i className="bi bi-briefcase" style={{ fontSize: 60, color: 'gray' }}></i>
        <h6 className="text-secondary">No jobs available</h6>
      </Container>
    );
  }

  return (
    <Container className="mt-3">
      <Row>
        <Col xs={12} md={4} lg={3}> {/* Left column for filters */}
          <JobFilters onFilter={handleFilter} />
        </Col>
        <Col xs={12} md={8} lg={9}> {/* Right column for job listings */}
          <Row>
            {filteredJobs.map((job, index) => (
              <Col xs={12} key={index}> {/* Make each job card span the full width */}
                <JobCard job={job} />
              </Col>
            ))}
          </Row>
        </Col>
      </Row>
    </Container>
  );
};

export default JobList;
